import { render } from "./TheAlarmStatesGenerals.vue?vue&type=template&id=6be551e2"
import script from "./TheAlarmStatesGenerals.vue?vue&type=script&lang=js"
export * from "./TheAlarmStatesGenerals.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__